import { Dispatch, SetStateAction, useEffect } from 'react';
import useBucketApi from '../../api/use-api';
import { fetchUptimeData } from '../../api/api-utils';
import {
  AppKeys,
  FrontEndMessages,
  LocationKeys,
  ParsedStatusesFrontend,
} from '../../utils/types';

/**
 * This function acts as a container (separate from UI) to query the health data
 * It also generates the frontend messages based on the health data
 * @constructor
 */
const QueryHealthData = ({
  dataSetter,
  loadingSetter,
}: {
  dataSetter: Dispatch<SetStateAction<ParsedStatusesFrontend>>;
  loadingSetter: Dispatch<SetStateAction<boolean>>;
}) => {
  const { bucketApiInstance } = useBucketApi();

  useEffect(() => {
    const downloadData = async (cancelOverride?: boolean) => {
      loadingSetter(true);
      const rawData = await fetchUptimeData(bucketApiInstance);
      const frontEndMessages: FrontEndMessages = {
        overallStatus: 'unknown',
        problemApps: [],
      };
      // iterate through data and generate frontend messages
      if (rawData && !cancelOverride) {
        const { apps } = rawData;
        // appKeys are values such as "admin.brianos.dev"
        const appKeys = Object.keys(apps) as string[];
        appKeys.forEach(appKey => {
          const { locations } = apps[appKey];
          const locationKeys = Object.keys(locations) as LocationKeys[];
          locationKeys.forEach(locationKey => {
            const { status } = locations[locationKey];
            if (status !== 'pass') {
              frontEndMessages.overallStatus = 'bad';
              // convert app key from "admin.brainos.dev" to just "admin"
              frontEndMessages.problemApps.push(
                appKey.split('.')[0] as AppKeys
              );
            }
          });
        });

        // consolidate duplicate entries of problem apps
        frontEndMessages.problemApps = Array.from(
          new Set(frontEndMessages.problemApps)
        );

        if (frontEndMessages.problemApps.length < 1) {
          frontEndMessages.overallStatus = 'good';
        }

        frontEndMessages.problemApps.sort();
        dataSetter({ rawData, ...frontEndMessages });
      } else {
        dataSetter(frontEndMessages);
      }

      loadingSetter(false);
    };

    // how to test switching between good and bad status
    // setTimeout(() => {
    //   downloadData(true);
    // }, 1000);

    downloadData();

    const interval = setInterval(() => {
      downloadData();
      // re-query every minute
    }, 60000);

    return () => clearInterval(interval);
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [dataSetter]);
  return <></>;
};

export default QueryHealthData;
